<template>
  <div w-fit flex items-center text-size="16px" cursor="pointer" color="#000000e6" class="back">
    <div v-if="isBack" @click="handleBack" mr-10px>
      <el-icon style="position: relative; top: 2px"><BackIcon /></el-icon> <span color="#606266">返回</span>
    </div>
    <el-divider v-if="isBack && showTitle" direction="vertical" />
    <div v-if="showTitle" :class="{ 'ml-10px': isBack }">
      <span color="#606266">当前页面：</span><span fw500>{{ currentPageTitle }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Back as BackIcon } from "@element-plus/icons-vue"
import { computed, toRefs } from "vue"
import { useRouter } from "vue-router"

const props = defineProps({
  name: {
    type: String,
    default: () => {
      return ""
    },
  },
  isBack: {
    type: Boolean,
    default: true,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
})

const { name } = toRefs(props)

const router = useRouter()

const currentPageTitle = computed(() => {
  if (name.value && name.value && name.value) {
    return name.value
  } else if (router.currentRoute.value.meta.title) {
    return router.currentRoute.value.meta.title
  } else {
    return ""
  }
})

const handleBack = () => {
  router.go(-1)
}
</script>

<style scoped lang="scss">
.back {
  display: flex;
  align-items: center;
  align-self: stretch;
  width: 100%;
  padding: 9px 16px;
  background: #fff;
}
</style>
